import ExamListComponent from "../../components/Exams/ExamListComponent"

const ExamList = () => <ExamListComponent kind="exam" />

export const WorksheetList = () => <ExamListComponent kind="worksheet" />

export const HomeworkList = () => <ExamListComponent kind="homework" />

export default ExamList
